__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = undefined;
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("launchdarkly-react-client-sdk", "3.3.2", () => (() => (__webpack_require__(76886))), 1);
			register("react-dom", "18.2.0", () => (() => (__webpack_require__(52304))), 1);
			register("react-redux", "7.2.9", () => (() => (__webpack_require__(13352))), 1);
			register("react-router-dom", "5.3.4", () => (() => (__webpack_require__(86490))), 1);
			register("react-toastify", "7.0.4", () => (() => (__webpack_require__(86406))), 1);
			register("react", "18.2.0", () => (() => (__webpack_require__(58961))), 1);
			register("sonner", "1.7.2", () => (() => (__webpack_require__(67134))), 1);
			initExternal(61354);
			initExternal(78606);
			initExternal(58702);
			initExternal(49824);
			initExternal(97222);
			initExternal(21110);
			initExternal(78284);
			initExternal(92938);
			initExternal(93560);
			initExternal(16304);
			initExternal(35764);
			initExternal(12994);
			initExternal(88438);
			initExternal(74078);
			initExternal(19054);
			initExternal(61016);
			initExternal(22846);
			initExternal(8898);
			initExternal(78742);
			initExternal(10472);
			initExternal(62928);
			initExternal(42158);
			initExternal(55526);
			initExternal(44342);
			initExternal(6302);
			initExternal(38478);
			initExternal(82350);
			initExternal(62406);
			initExternal(5308);
			initExternal(91678);
			initExternal(42166);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};